import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../molecules/Modal';
import Checkbox from '../../../atoms/Checkbox';
const TableColumnsModal = ({ activeColumns, config, ...modalProps }) => {
    const { t } = useTranslation();
    const [state, setState] = React.useState(activeColumns);
    const onToggle = (property) => () => {
        setState(prevState => {
            if (prevState.includes(property))
                return prevState.filter(x => x !== property);
            return Array.from(new Set([...prevState, property]));
        });
    };
    const onCancel = () => modalProps.onClose();
    const onSave = () => modalProps.onClose(state);
    return (_jsxs(Modal, { ...modalProps, title: t('dossier.table.column_settings.title'), children: [config
                .filter(({ when }) => typeof when !== 'function')
                .map(({ property, columnName }) => (_jsx(Checkbox, { label: columnName ? t(columnName) : columnName, "data-property": property, defaultChecked: state.includes(property), onChange: onToggle(property) }, property))), _jsxs(Modal.Actions, { children: [_jsx(Modal.Actions.Secondary, { onClick: onCancel, children: t('buttons.cancel') }), _jsx(Modal.Actions.Primary, { onClick: onSave, children: t('buttons.save') })] })] }));
};
export default TableColumnsModal;
